import { CommonGet, CommonPost } from "../../../utils/CommonFetch";

export default {
    saveRoute,
    editData,
    getFactoryByGroupID,
    getAllOperationEntitiesForDropDown,
    GetCollectionCategoryByOperationEntityID,
    getRouteFilterData
};

async function saveRoute(data){
    let route = {
        collectionPointID: 0,
        collectionPointCode: data.collectionPointCode,
        collectionPointName: data.collectionPointName.trim(),
        collectionPointLocation: data.collectionPointLocation.trim(),
        operationEntityID: parseInt(data.operationEntityID),
        collectionCategoryID: parseInt(data.collectionCategoryID),
        operationEntityTypeID: 1,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive,
        groupID: parseInt(data.groupID),
        FactoryWeighValidationEnabled: data.factoryWeighValidationEnabled
    }
    const response = await CommonPost('/api/CollectionPoint/SaveRoute', null, route);
    return response;
}
async function editData(data) {
    let route = {
        collectionPointID: data.collectionPointID,
        collectionPointCode: data.collectionPointCode,
        collectionPointName: data.collectionPointName.trim(),
        collectionPointLocation: data.collectionPointLocation.trim(),
        operationEntityID: parseInt(data.operationEntityID),
        collectionCategoryID: parseInt(data.collectionCategoryID),
        operationEntityTypeID: 1,
        createdBy: data.createdBy,
        createdDate: data.createdDate,
        modifiedBy: data.modifiedBy,
        modifiedDate: new Date().toISOString(),
        isActive: data.isActive,
        groupID: parseInt(data.groupID),
        FactoryWeighValidationEnabled: data.factoryWeighValidationEnabled
    }
    const response = await CommonPost('/api/CollectionPoint/UpdateRoute', null, route);
    return response;
}

async function getRouteFilterData(data) {
    var routeFilterModel = {
        groupID: data.groupID,
        operationEntityID: data.operationEntityID,
        collectionCategoryID: data.collectionCatagoryID,
    }
    
    const response = await CommonPost('/api/CollectionPoint/FilterRoute', null, routeFilterModel);
    return response.data;

}

async function getOperationentityCollectionCatagoryFilterData(data) {
    var filterModel = {
        operationEntityID: data.operationEntityID,
        productID: data.productID,
        collectionCatagoryID: ""
    }
    const response = await CommonPost('/api/OpearationentityCollectionCatagoryMapping/FilterOpearationentityCollectionCatagory', null, filterModel);
    return response.data;
}

async function getFactoryByGroupID(id) {
    var factoryArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllFactoriesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            factoryArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return factoryArray;

    
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function GetCollectionCategoryByOperationEntityID(id) {
    var collectionCategoryArray = [];
    const response = await CommonGet('/api/CollectionCategory/GetCollectionCategoryByOperationEntityID', 'operationEntityID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            collectionCategoryArray[item[1]["collectionCategoryID"]] = item[1]["collectionCategoryName"]
        }
    }
    return collectionCategoryArray;
}